import type {
    ComponentStageData,
    MobileAlgoPlugin,
    MobileAlgoPluginInitializationArgs,
    PluginHeuristicsRegistry
} from '../../types'
import {hideComponentsHeuristics} from './heuristicDefinition'
import {createAdaptiveHeuristic} from '../common'

export const createPlugin = ({stages}: MobileAlgoPluginInitializationArgs): MobileAlgoPlugin => {
    const hideComponents = (componentStageData: ComponentStageData) => {
        const heuristicToApply = hideComponentsHeuristics.find(({predicate}) => predicate(componentStageData))!

        if (!heuristicToApply) {
            return
        }

        heuristicToApply.apply(componentStageData)

        return {
            appliedHeuristics: ['HIDE VERTICAL LINE']
        }
    }

    const register = (registry: PluginHeuristicsRegistry) => {
        registry.register(stages.HIDE_COMPONENTS, createAdaptiveHeuristic(hideComponents))
    }

    return {register, name: 'hide', dependencies: []}
}
